import { useAuth } from '@/hooks/useAuth';

/**
 * Single source of truth for permission-gated UI, per
 * documentation/architecture/MASTER_ARCHITECTURE.md §8 ("never ad hoc
 * `if (role === 'admin')` scattered through components"). This is a
 * UX convenience only — the API re-checks every permission server-side
 * regardless of what this hook allows the UI to show.
 */
export function usePermission(slug: string): boolean {
  const { hasPermission } = useAuth();
  return hasPermission(slug);
}
